import React, { useEffect, useState } from 'react'

const EVENT_NAME = 'cart:new-size'

// Cart item count badge for the site’s top-right header.
//
// This monitors a document-wide 'cart:increase' DOM custom event that provides
// added size info.
export default function Cart({
  size: initialSize,
  title,
}: {
  size: number
  title: string
}) {
  const [size, setSize] = useState(initialSize)

  useEffect(() => {
    document.addEventListener(EVENT_NAME, updateSize)

    return () => {
      document.removeEventListener(EVENT_NAME, updateSize)
    }
  }, [])

  if (size === 0) {
    return (
      <>
        <span>{title}</span>
        <b className='visually-hidden'>aucun article</b>
      </>
    )
  }

  return (
    <>
      <span>{title}</span>
      <b>{size}</b>
      <span className='visually-hidden'>
        {' '}
        {size > 1 ? 'articles' : 'article'}
      </span>
    </>
  )

  function updateSize({ detail: { size } }: CustomEventInit) {
    setSize(size)
  }
}

export function notifyCartBadge(size: number) {
  document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { size } }))
}
